import Checkbox from "@/common/elements/InputElements/CheckBox";
import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import TextField from "@/common/elements/InputElements/TextField";
import { IntakeSectionHeader } from "@/common/styles";
import { forwardRef } from "react";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import CommonDatePicker from "@/common/elements/DatePicker";
import Select from "@/common/elements/InputElements/Select";
import { getOptionsFromRefList, hasCheckSecurity } from "@/util/common_function";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { SCHEMA_FIELD_NAME, SCHEMA_NAME } from "@/util/common_variable";
import { useSelector } from "react-redux";

const ClearanceInformation = ({ changeClearReason,startingPoint="" }) => {
  const { bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const fullSearch = useSelector(state => state.fullSearch);
  return (
    <>
      <IntakeSectionHeader>
        <span>Clearance Information</span>
      </IntakeSectionHeader>
      <FormContainer>
        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
        >
          <Col className="gutter-row" span={8}>
            <FormItem name="clearedBy" label="Cleared By" layout="vertical">
              <Select
                options={getOptionsFromRefList("", true, false, true)}
                placeholder="Cleared By"
                variant="outlined"
                disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CHARGE_DESCRIPTION_ID, startingPoint)}
                className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", SCHEMA_NAME.CHARGES, SCHEMA_FIELD_NAME.CHARGE_DESCRIPTION_ID, startingPoint) ? "" : "input-control-mask"}
              />
            </FormItem>
          </Col>
          <Col className="gutter-row" span={8}>
            <FormItem
              name="clearanceDateTime"
              label="Clearance Date & Time"
              layout="vertical"
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY HH:mm"
                format="MM/DD/YYYY HH:mm"
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </Col>
          <Col className="gutter-row" span={8}>
            <FormItem name="clearanceReasonID" label="Reason" layout="vertical"  rules={!fullSearch ? [
                {
                  required: true,
                  message: "Clearance Reason is required",
                },
              ] : []}>
              <Select
                options={getOptionsFromRefList(
                  "ChargeClearance",
                  false,
                  false,
                  true
                )}
                placeholder="Cleared Reason"
                variant="outlined"
                onChange={changeClearReason}
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </Col>
        </Row>
      </FormContainer>
    </>
  );
};

export default ClearanceInformation;
